import { NgModule } from "@angular/core";
import { AuthGuardService, grupo, tipo } from './../../guards/auth-guard.service';
import { RouterModule, Routes } from "@angular/router";
import { ListagemChamadosComponent } from "./listagem-chamados/listagem-chamados.component";
import { InteracaoChamadoComponent } from "./interacao-chamado/interacao-chamado.component";
import { CriacaoChamadoComponent } from "./criacao-chamado/criacao-chamado.component";


const routes: Routes = [
  {
    path: '', component: ListagemChamadosComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'interacao/:uuid',
    component: InteracaoChamadoComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'abertura',
    component: CriacaoChamadoComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'abertura/:uuid_orcamento',
    component: CriacaoChamadoComponent,
    canActivate: [AuthGuardService]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChamadosRoutingModule { }
